import { AgeGroupClient, baseUrl } from '../api';
import { BaseActionReducer } from './baseActionReducer';
export const ageGroupActionReducer = new BaseActionReducer({ keyStart: 'AGE_GROUPS', payloadName: 'ageGroups' });
const syncAgeGroupActions = ageGroupActionReducer.buildSyncActions();
const ageGroupClient = new AgeGroupClient(null, baseUrl);
const asyncAgeGroupActionCreators = {
    getAll: () => {
        return ageGroupActionReducer.createAsyncAction(ageGroupClient.getAll());
    },
    get: (ageGroupId) => {
        return ageGroupActionReducer.createAsyncAction(ageGroupClient.get(ageGroupId));
    }
};
export const ageGroupActions = Object.assign(Object.assign({}, syncAgeGroupActions), asyncAgeGroupActionCreators);
